import { Alert, Button, Card, Checkbox, Form, Input, message, Typography } from "antd";
import { CloudUploadOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useState } from "react";
import { login } from "../services/authService";

const { Text, Title } = Typography;

export default function SignIn() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const history = useHistory();
  const location = useLocation();

  const submit = async (values) => {
    setLoading(true);
    setError("");
    try {
      await login(values);
      message.success("Đăng nhập thành công");
      history.replace(location.state?.from || "/dashboard");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return <div className="auth-page auth-login-page">
    <div className="auth-pattern auth-pattern-dots" />
    <div className="auth-pattern auth-pattern-stripes" />
    <Card className="auth-card auth-login-card" bordered={false}>
      <div className="auth-login-logo"><CloudUploadOutlined /></div>
      <div className="auth-brand auth-login-brand">AUTO UPLOAD</div>
      <Title level={1}>Đăng nhập</Title>
      <Text className="auth-login-subtitle">Sử dụng tài khoản Auto Upload để tiếp tục.</Text>
      {error && <Alert className="auth-alert" type="error" showIcon message={error} />}
      <Form layout="vertical" initialValues={{ remember: true }} onFinish={submit}>
        <Form.Item label="TÊN ĐĂNG NHẬP" name="username" rules={[{ required: true, message: "Nhập tên đăng nhập" }]}>
          <Input size="large" prefix={<UserOutlined />} placeholder="Nhập tên đăng nhập" autoComplete="username" />
        </Form.Item>
        <Form.Item label="MẬT KHẨU" name="password" rules={[{ required: true, message: "Nhập mật khẩu" }]}>
          <Input.Password size="large" prefix={<LockOutlined />} placeholder="Nhập mật khẩu" autoComplete="current-password" />
        </Form.Item>
        <div className="auth-login-options">
          <Form.Item name="remember" valuePropName="checked" noStyle><Checkbox>Ghi nhớ đăng nhập</Checkbox></Form.Item>
          <button type="button" className="auth-forgot" onClick={() => message.info("Chức năng quên mật khẩu sẽ được bổ sung")}>Quên mật khẩu?</button>
        </div>
        <Button className="auth-login-submit" block size="large" type="primary" htmlType="submit" loading={loading}>Đăng nhập</Button>
      </Form>
      <div className="auth-divider"><span>HOẶC</span></div>
      <div className="auth-register-copy"><Text>Chưa có tài khoản?</Text> <Link to="/sign-up">Đăng ký</Link></div>
    </Card>
  </div>;
}
